import React, { useState } from 'react';
import '../NovelSection/NovelSection.css';
import PreorderModal from '../PreorderModal/PreorderModal';
import ComingSoonModal from '../ComingSoonModal/ComingSoonModal';
import { useCart } from '../../context/CartContext';

const NovelSection = () => {
  const [selectedBook, setSelectedBook] = useState(null);
  const [showReader, setShowReader] = useState(false);
  const [showPreorder, setShowPreorder] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [comingSoonBook, setComingSoonBook] = useState(null);

  const { addToCart } = useCart();

  const books = [
    { id: 1, title: 'Book One', author: 'Mardukson', cover: 'book1.jpg', image: 'book1.jpg', pdf: 'book1.pdf', price: 1500, name: 'Book One' },
    { id: 2, title: 'Book Two', author: 'Mardukson', cover: 'book2.jpg', image: 'book2.jpg', pdf: 'book2.pdf', price: 1500, name: 'Book Two' },
    { id: 3, title: 'Book Three', author: 'Mardukson', cover: 'book3.jpg', image: 'book3.jpg', pdf: 'book3.pdf', price: 1500, name: 'Book Three' },
    { id: 4, title: 'Book Four', author: 'Mardukson', cover: 'book4.jpg', image: 'book4.jpg', pdf: 'book4.pdf', price: 1500, name: 'Book Four' },
    { id: 5, title: 'Book One (with Soundtrack)', author: 'Mardukson', cover: 'book1.jpg', image: 'book1.jpg', pdf: 'book5.pdf', price: 2200, name: 'Book One (with Soundtrack)' },
    { id: 6, title: 'Book Two (with Soundtrack)', author: 'Mardukson', cover: 'book2.jpg', image: 'book2.jpg', pdf: 'book6.pdf', price: 2200, name: 'Book Two (with Soundtrack)' },
    { id: 7, title: 'Book Three (with Soundtrack)', author: 'Mardukson', cover: 'book3.jpg', image: 'book3.jpg', pdf: 'book7.pdf', price: 2200, name: 'Book Three (with Soundtrack)' },
    { id: 8, title: 'Book Four (with Soundtrack)', author: 'Mardukson', cover: 'book4.jpg', image: 'book4.jpg', pdf: 'book8.pdf', price: 2200, name: 'Book Four (with Soundtrack)' }
  ];

  const handleAddToCart = (book) => {
    addToCart(book);
  };

  const handleBookClick = (book) => {
    setSelectedBook(book);
    setShowReader(true);
  };

  const handleCloseReader = () => {
    setShowReader(false);
    setSelectedBook(null);
  };

  const handlePreorder = (book) => {
    setSelectedBook(book);
    setShowPreorder(true);
  };

  const handleClosePreorder = () => {
    setShowPreorder(false);
    setSelectedBook(null);
  };

  const handleBuyClick = (book) => {
    setComingSoonBook(book);
    setShowComingSoon(true);
  };

  const handlePrevious = () => {
    const currentIndex = books.findIndex(b => b.id === selectedBook.id);
    if (currentIndex > 0) setSelectedBook(books[currentIndex - 1]);
  };

  const handleNext = () => {
    const currentIndex = books.findIndex(b => b.id === selectedBook.id);
    if (currentIndex < books.length - 1) setSelectedBook(books[currentIndex + 1]);
  };

  return (
    <div className="novel-section">
      <div className="novel-container">
        <h1 className="novel-title">Novels</h1>

        {/* Grid of Book Cards */}
        <div className="novel-grid">
          {books.map(book => (
            <div key={book.id} className="novel-card">
              <div className="novel-cover-wrapper">
                <img src={book.cover} alt={book.title} className="novel-cover" />
                <div className="novel-overlay" />

                {/* Cart Icon */}
                <button
                  className="cart-icon-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToCart(book);
                  }}
                  aria-label={`Add ${book.title} to cart`}
                  style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    background: 'rgba(206, 0, 33, 0.9)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    color: 'white',
                    fontSize: '18px',
                    zIndex: 10
                  }}
                >
                  🛒
                </button>
              </div>

              <h3 className="novel-book-title">{book.title}</h3>
              <p className="novel-author">{book.author}</p>

              <div className="novel-buttons">
                <button
                  className="novel-btn novel-btn-preorder"
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePreorder(book);
                  }}
                >
                  PreOrder
                </button>
                <button
                  className="novel-btn novel-btn-buy"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBuyClick(book);
                  }}
                >
                  Buy
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleBookClick(book);
                  }}
                  className="novel-btn novel-btn-read"
                >
                  Read More
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* PDF Reader Modal */}
        {showReader && selectedBook && (
          <div className="novel-modal-overlay" onClick={handleCloseReader}>
            <div className="novel-modal" onClick={e => e.stopPropagation()}>
              <div className="novel-modal-header">
                <h2 className="novel-modal-title">{selectedBook.title}</h2>
                <button className="novel-modal-close" onClick={handleCloseReader}>&times;</button>
              </div>
              <div className="novel-modal-content">
                <iframe
                  src={selectedBook.pdf}
                  title={selectedBook.title}
                  className="novel-modal-iframe"
                />
              </div>
              <div className="novel-modal-footer">
                <button onClick={handlePrevious} disabled={books.findIndex(b => b.id === selectedBook.id) === 0}>Previous</button>
                <button onClick={handleCloseReader}>Close</button>
                <button onClick={handleNext} disabled={books.findIndex(b => b.id === selectedBook.id) === books.length - 1}>Next</button>
              </div>
            </div>
          </div>
        )}

        {/* Preorder Modal */}
        {showPreorder && selectedBook && (
          <PreorderModal
            product={{ ...selectedBook, image: selectedBook.image || selectedBook.cover }}
            onClose={handleClosePreorder}
          />
        )}

        {/* Coming Soon Modal */}
        {showComingSoon && comingSoonBook && (
          <ComingSoonModal
            product={{ ...comingSoonBook, image: comingSoonBook.image || comingSoonBook.cover }}
            onClose={() => {
              setShowComingSoon(false);
              setComingSoonBook(null);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default NovelSection;
